import React from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Button from '../common/Button';
import { Chart } from 'react-google-charts';

const WalletBalance = (props) => {
  const classes = props.classes;
  return (<div className="flex justify-content-between">
    <Card className={`${classes.root}`}>
      <CardContent classes={{ root: classes.card1 }}>
        <h3 className={'mb-3'}> <strong>Gloabal Wallet Total Balance</strong> </h3>
        <div className={classes.balance}>
          <Typography className="w-100 text-center" variant="h5"> $ 10,25,0000 </Typography>
          <div className={classes.balanceActions}>
            <Button size="small" label="Withdraw to Bank" className={'mr-2'} onClick={() => console.log("CLicked")}></Button>
            <Button size="small" label="Download e-Statement" className={classes.download} onClick={() => console.log("CLicked")}></Button>
          </div>
        </div>
      </CardContent>
    </Card>
    <Card className={`${classes.root1}`}>
      <CardContent>
        <div className="mb-4">
          <h3 className={'mb-3'}> <strong>Payment Transactions Summary</strong> </h3>
          <div className={classes.paymentsummary}>
            <div>
              <Typography variant="p"> Total Received </Typography>
              <Typography variant="h6"> $ 2,55,000 </Typography>
            </div>
            <div>
              <Typography variant="p"> Total Sent </Typography>
              <Typography variant="h6"> $ 1,17,000 </Typography>
            </div>
          </div>
        </div>
        <Chart
          width={'100%'}
          height={'250px'}
          chartType="Bar"
          loader={<div>Loading Chart</div>}
          data={[
            ['', '2010 Population', '2000 Population'],
            ['11 Mar', 10000, 5000],
            ['12', 16000, 7000],
            ['13', 13000, 8000],
            ['14', 20000, 10000],
            ['15', 6000, 23000],
          ]}
          options={{
            title: 'Population of Largest U.S. Cities',
            chartArea: { width: '50%' },
            hAxis: { title: '', legend: 'none', minValue: 0 },
            yAxis: { title: '', legend: 'none', minValue: 0 },
            colors: ['#f58634', '#409443'],
            legend: { position: 'none', maxLines: 1 },
          }}
          rootProps={{ 'data-testid': '3' }}
        />
      </CardContent>
    </Card>
  </div>)
};

export default WalletBalance;
